export default __webpack_public_path__ + "static/glass-d794897f07a545461070278a133fc8cf.svg";